import React from 'react';
import Dialog from '@common_dialog';
import { COLORS } from '@theme_vars';
import { getCmsBlocks } from '@core_modules/cms/services/graphql';
import CmsRenderer from '@core_modules/cms/components/cms-renderer';
import Skeleton from '@common_skeleton';

const ProductLabelDesc = (props) => {
    const {
        open, handleClose, identifier, storeConfig, label,
    } = props;

    const { data: dataProductLabelDesc, loading: loadingProductLabelDesc } = getCmsBlocks({ identifiers: identifier });
    const cmsProductLabelDesc = dataProductLabelDesc?.cmsBlocks?.items[0].content;

    return (
        <Dialog
            open={open}
            closeOnBackdrop
            onClose={() => handleClose()}
            onClickCloseTitle={() => handleClose()}
            title={label}
            useCloseTitleButton
            classWrapperTitle="pb-[5px]"
            classTitle="text-[20px] !text-neutral-black"
            content={(
                <>
                    <div className="flex flex-col">
                        <div className="flex flex-col gap-4 relative h-full">
                            <div className="desc-wrapper flex flex-col gap-2 relative h-full mb-1 max-h-[50vh] overflow-y-auto">
                                {
                                    !cmsProductLabelDesc && loadingProductLabelDesc ? (
                                        <>
                                            <Skeleton width="100%" height={40} />
                                            <Skeleton width="100%" height={20} className="mt-[10px]" />
                                            <Skeleton width="100%" height={20} className="mt-[5px]" />
                                            <Skeleton width="100%" height={20} className="mt-[5px]" />
                                        </>
                                    ) : (
                                        <div className="cms-product-label-desc leading-[0px]">
                                            <CmsRenderer content={cmsProductLabelDesc} storeConfig={storeConfig} />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    <style jsx>
                        {`
                        .desc-wrapper::-webkit-scrollbar-track {
                            background: 0 0;
                        }
                        .desc-wrapper::-webkit-scrollbar-thumb {
                            background-color: ${COLORS.secondary[600]};
                            border-radius: 8px;
                            border: 1px solid transparent;
                        }
                        .desc-wrapper::-webkit-scrollbar {
                            width: 8px;
                        }
                        .desc-wrapper {
                            overflow-x: hidden;
                            padding: 0;
                            scrollbar-width: thin;
                            scrollbar-color: ${COLORS.secondary[600]} transparent;
                        }
                    `}
                    </style>
                    <style jsx global>
                        {`
                            .cms-product-label-desc .prose {
                                max-width: 100% !important;
                            }
                        `}
                    </style>
                </>
            )}
        />
    );
};

export default ProductLabelDesc;
